const SPACEBAR_CODE = 32;

document.addEventListener('DOMContentLoaded', function () {
  initializeCardV2ButtonInteractions();
});

function initializeCardV2ButtonInteractions() {
  const cardComponents = document.querySelectorAll('.card');

  cardComponents.forEach((card) => {
    const cardButtons = card.querySelectorAll('a.mh-emit');

    cardButtons.forEach((button) => {
      const hasUrl = Boolean(button.href);
      if (hasUrl) {
        // Remove any existing keydown listeners to prevent duplicates
        button.removeEventListener('keydown', handleCardButtonKeydown);

        button.addEventListener('keydown', handleCardButtonKeydown);
      }
    });
  });
}

function handleCardButtonKeydown(event) {
  if (event.keyCode === SPACEBAR_CODE || event.code === 'Space') {
    event.preventDefault(); // Prevent page scrolling

    const button = event.currentTarget;
    button.click();
  }
}
